import React from "react";
import classNames from "classnames";
// import AddRetailerModal from "./AddRetailerModal";

import LiveIcon from "../../assets/media/icons/live.svg";
import InactiveIcon from "../../assets/media/icons/inactive.svg";

import "./index.css";
import { Link } from "react-router-dom";
import {
  CurrencyOptions,
  TerritoryOptions,
  RetailerVoucherOptions,
} from "../../Constants/retailer";

class Retailer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      total: 0,
      open: 0,
      close: 0,
      waiting: 0,
    };
  }

  onEdit = (event) => {
    const { onEdit, id, retailer } = this.props;
    event.stopPropagation();
    onEdit(id, retailer.voucherType);
  };

  getTokenString = (name) => {
    const { retailer } = this.props;
    const token = retailer[name];

    if (token && token.tokenPercentage) {
      return `${
        token.fullTokens + token.partTokens
      } shopping tokens for every ${
        CurrencyOptions[retailer.territory || TerritoryOptions[0]]
      }${token.threshold} spent`;
    }

    return "Not available currently";
  };

  render() {
    const {
      retailer,
      onClick,
      deactive,
      readOnly,
      mode,
      isSuper = false,
    } = this.props;
    const isInactive = deactive === "deactive";

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 10,
        }}
      >
        <div className="retailer-content" onClick={onClick}>
          <div className="block block-rounded block-link-pop text-center">
            <div
              style={{
                backgroundImage: `url(${
                  retailer.logo ? retailer.logo : retailer
                })`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
                padding: 20,
                width: "100%",
                height: 150,
              }}
            ></div>
            {isSuper && (
              <div className="text-center voucher-content">
                {
                  RetailerVoucherOptions.find(
                    (voucher) =>
                      voucher.value === (retailer.voucherType || "wegift")
                  ).label
                }
              </div>
            )}
            {!readOnly && (
              <div className="status-container">
                <div
                  className={classNames("status", {
                    inactive: isInactive,
                  })}
                >
                  <img src={isInactive ? InactiveIcon : LiveIcon} alt="icon" />
                  {isInactive ? "INACTIVE" : "LIVE"}
                </div>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={this.onEdit}
                >
                  Edit
                </button>
              </div>
            )}
            {readOnly && (
              <React.Fragment>
                {mode === 1 && (
                  <React.Fragment>
                    <p className="token-details-section">Redeem</p>
                    <p className="token-details-value">
                      {this.getTokenString("redeemed")}
                    </p>
                    <p className="token-details-value">
                      Unlimited premier
                      <br />
                      tokens spending
                    </p>
                  </React.Fragment>
                )}
                {mode === 2 && (
                  <React.Fragment>
                    <p className="token-details-section">Earn</p>
                    <p className="token-details-value">
                      {this.getTokenString("gift")}
                    </p>
                  </React.Fragment>
                )}
                {mode !== 1 && mode !== 2 && (
                  <React.Fragment>
                    <p className="token-details-section">Redeem</p>
                    <p className="token-details-value">
                      {this.getTokenString("redeemed")}
                    </p>
                    <p className="token-details-section">Earn</p>
                    <p className="token-details-value">
                      {this.getTokenString("gift")}
                    </p>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </div>
        </div>
        {/* {!readOnly && (
          <AddRetailerModal
            id={id}
            retailers={retailers}
            initialValue={retailer}
            onSave={onEdit}
            onDelete={onDelete}
          />
        )} */}
      </div>
    );
  }
}
export default Retailer;



// WEBPACK FOOTER //
// ./src/components/Retailer/index.js